import React from 'react';
import UserDetail from '../../component/UserProfile/UserDetail';

const UserDetailContainer = () => {
  return <UserDetail />;
};

export default UserDetailContainer;
